export default "__VITE_ASSET__d38eb8e9__"